module.exports = __webpack_public_path__ + "static/media/TableManifest.fa1e1e27.csv";